import { PageHeader } from 'components';
import { Results } from './components';


let TicketInbox = () => {
    return (
        <>
            <PageHeader pageTitle="Ticket inbox" />
            <Results />
        </>
    );
}

export default TicketInbox;